'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowUpRightAndArrowDownLeft, iconArrowUpRightAndArrowDownLeftTag } from '@ni/nimble-components/dist/esm/icons/arrow-up-right-and-arrow-down-left';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowUpRightAndArrowDownLeft };
export { iconArrowUpRightAndArrowDownLeftTag };
export const NimbleIconArrowUpRightAndArrowDownLeft = wrap(IconArrowUpRightAndArrowDownLeft);